import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded'
import { Box, Breadcrumbs, Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { paths } from '@/routes/paths'
import { setOperatorClientView } from '@/routes/platformView'
import { platformSurfaces } from '@/super-admin/theme'

/** Título de sección a partir de la ruta (solo presentación). */
const SECTIONS: [string, string][] = [
  [paths.superAdminAgentOps, 'Agent Ops'],
  [paths.superAdminOrganizations, 'Organizaciones'],
  [paths.superAdminUsers, 'Usuarios'],
  [paths.superAdminPlans, 'Planes y contratos'],
  [paths.superAdminSources, 'Fuentes'],
  [paths.superAdminCosts, 'Costos IA'],
  [paths.superAdminAiUsage, 'Costos IA'],
  [paths.superAdminHealth, 'Salud'],
  [paths.superAdminAudit, 'Auditoría'],
  [paths.superAdminSettings, 'Configuración'],
]

function sectionFor(pathname: string): string {
  return SECTIONS.find(([prefix]) => pathname.startsWith(prefix))?.[1] ?? 'Resumen'
}

const ENVIRONMENT = import.meta.env.MODE === 'production' ? 'PRODUCCIÓN' : 'LOCAL'

export function PlatformTopbar() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Box component="header" sx={{ position: 'sticky', top: 0, zIndex: 10, bgcolor: platformSurfaces.topbar }}>
      <Box sx={{ height: 3, background: platformSurfaces.accentStripe }} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ px: 3, py: 1.25, borderBottom: `1px solid ${platformSurfaces.border}` }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Breadcrumbs aria-label="Ubicación" separator="›">
            <Typography variant="body2" color="text.secondary">
              Platform Console
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {sectionFor(location.pathname)}
            </Typography>
          </Breadcrumbs>
          <Chip
            size="small"
            label={ENVIRONMENT}
            color={ENVIRONMENT === 'PRODUCCIÓN' ? 'error' : 'secondary'}
            variant="outlined"
            sx={{ height: 20, fontSize: '0.62rem', letterSpacing: 0.6 }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {user?.organization_id && (
            <Tooltip title="Abrir la app cliente con tu organización (elección explícita)">
              <Button
                size="small"
                color="inherit"
                variant="outlined"
                startIcon={<OpenInNewRoundedIcon fontSize="small" />}
                onClick={() => {
                  setOperatorClientView(true)
                  navigate(paths.dashboard)
                }}
              >
                App cliente
              </Button>
            </Tooltip>
          )}
          <Stack sx={{ textAlign: 'right', px: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
              {user?.full_name || user?.email}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Operador de plataforma
            </Typography>
          </Stack>
          <Tooltip title="Cerrar sesión">
            <IconButton
              size="small"
              aria-label="Cerrar sesión"
              onClick={() => {
                setOperatorClientView(false)
                void logout()
              }}
            >
              <LogoutRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
    </Box>
  )
}
